import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TextGenerationRequest,
  TextGenerationResponse,
  AITextGenerationState,
} from '../types/ai-text-generation.types';

const initialState: AITextGenerationState = {
  isGenerating: false,
  isStreaming: false,
  generatedText: '',
  error: null,
  currentRequest: null,
  streamingText: '',
  consentRequired: false,
};

const aiTextGenerationSlice = createSlice({
  name: 'aiTextGeneration',
  initialState,
  reducers: {
    generateTextRequest: (state, action: PayloadAction<TextGenerationRequest>) => {
      state.isGenerating = true;
      state.isStreaming = false;
      state.error = null;
      state.consentRequired = false;
      state.currentRequest = action.payload;
      state.generatedText = '';
      state.streamingText = '';
    },
    // PMO #23381: sin consentimiento NO es un fallo de la generación: se conserva `currentRequest` para repetirla.
    generateTextConsentRequired: (state) => {
      state.isGenerating = false;
      state.isStreaming = false;
      state.error = null;
      state.consentRequired = true;
      state.generatedText = '';
      state.streamingText = '';
    },
    generateTextChunk: (state, action: PayloadAction<string>) => {
      state.isStreaming = true;
      state.isGenerating = false; // El loader desaparece cuando comienza el streaming
      state.streamingText += action.payload;
      state.generatedText = state.streamingText;
    },
    generateTextSuccess: (state, action: PayloadAction<TextGenerationResponse>) => {
      state.isGenerating = false;
      state.isStreaming = false;
      state.generatedText = action.payload.text;
      state.streamingText = action.payload.text;
      state.error = null;
    },
    generateTextFailure: (state, action: PayloadAction<string>) => {
      state.isGenerating = false;
      state.isStreaming = false;
      state.error = action.payload;
      state.generatedText = '';
      state.streamingText = '';
    },
    resetTextGeneration: (state) => {
      state.isGenerating = false;
      state.isStreaming = false;
      state.generatedText = '';
      state.error = null;
      state.consentRequired = false;
      state.currentRequest = null;
      state.streamingText = '';
    },
  },
});

export const {
  generateTextRequest,
  generateTextChunk,
  generateTextSuccess,
  generateTextFailure,
  generateTextConsentRequired,
  resetTextGeneration,
} = aiTextGenerationSlice.actions;

export default aiTextGenerationSlice.reducer;



